// On se permet d'utiliser une mémoire partagée simple car les données ne sont jamais changées
// En cas de besoin plus complexe utiliser vuex

const store = {
    project: null,
    url: null,
    table: null,
    table_news: null,

    metadata: null,
    services: null,
    news: null,
    files: null
};

export default store;
